<!--
  ОТЛАДКА ВИДЕО В КОЛЛАЖЕ:
  1. Откройте консоль браузера (F12)
  2. Попробуйте кликнуть на видео в коллаже
  3. Ищите логи с эмодзи: 🎬, 🎥, 🔧, 🚪
  4. Если видео не открывается, проверьте:
     - Срабатывает ли slide_before_load для типа 'video'
     - Находится ли media container
     - Есть ли ошибки при инъекции видео
  5. После выявления проблемы, уберите console.log для продакшена
-->
<template>
  <div ref="div">
    <a
      v-for="(item, idx) in items"
      :key="idx"
      :href="getMediaUrl(item)"
      :class="item.type !== 'reel' ? 'glightbox-' + tuid : ''"
      :data-gallery="tuid"
      :data-type="getMediaType(item)"
      :data-width="item.type === 'video' ? '90vw' : ''"
      :data-height="item.type === 'video' ? '80vh' : ''"
      :target="item.type === 'reel' ? '_blank' : ''"
      rel="noopener noreferrer"
    >
      <component
        :is="item.type === 'video' ? 'video' : 'img'"
        :src="getImageUrl(item)"
        v-bind="getMediaAttributes(item)"
        loading="lazy"
        @loadstart="onMediaLoad(item, $event)"
        @error="onMediaError(item, $event)"
        @loadedmetadata="onVideoMetadataLoaded(item, $event)"
      />
      <div class="video-play" v-if="item.type === 'video' || item.type === 'reel'">
        <span></span>
      </div>
      <span class="content-type play" v-if="item.type === 'video'"></span>
    </a>
  </div>
</template>

<script>
import GLightbox from 'glightbox';

export default {
  name: 'CollageItems',
  props: ['items', 'className', 'padding', 'tuid', 'befLoad'],
  data() {
    return {
      resizeTimeout: null,
      loadedMediaCount: 0,
      totalMediaCount: 0,
      lightboxInitialized: false,
    };
  },
  mounted() {
    if (!this.$options.propsData?.items.length || !this.$refs.div) return;

    this.$refs.div.className = this.$options.propsData.className;
    this.initializeCollage();
    window.addEventListener('resize', this.resizes);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizes);
  },
  methods: {
    /* ---------- helpers for URLs & attrs ---------- */
    getMediaUrl(item) {
      if (item.type === 'reel') return item.post_url;
      if (item.type === 'video' && item.video_url) return item.video_url;
      return item.image_url;
    },
    getMediaType(item) {
      return item.type === 'video' ? 'video' : item.type === 'photo' ? 'image' : item.type;
    },
    getImageUrl(item) {
      // use the same url for the thumb if no poster
      if (item.type === 'video' && item.video_url) return item.video_url;
      return item.image_url;
    },
    getMediaAttributes(item) {
      if (item.type === 'video') {
        return {
          muted: true,
          playsinline: true,
          preload: 'metadata',
          style: 'object-fit: cover;',
          // no poster available
        };
      }
      return {};
    },

    /* ---------- loaders ---------- */
    onMediaLoad() {},
    onMediaError() {
      this.onMediaLoadComplete();
    },
    onVideoMetadataLoaded() {
      this.onMediaLoadComplete();
    },

    /* ---------- collage ---------- */
    initializeCollage() {
      this.totalMediaCount = this.$options.propsData?.items.length || 0;
      this.loadedMediaCount = 0;
      this.lightboxInitialized = false;

    Array.from(this.$refs.div.children).forEach((gl) => {
        const el = gl.children[0];
        if (el.tagName === 'IMG') {
          el.onload = this.onMediaLoadComplete;
          el.onerror = this.onMediaLoadComplete;
        }
      });

      if (this.totalMediaCount === 0) this.finalizeCollage();
    },
    onMediaLoadComplete() {
      this.loadedMediaCount++;
      if (this.loadedMediaCount >= this.totalMediaCount && !this.lightboxInitialized) {
        this.$nextTick(() => this.finalizeCollage());
      }
    },
    finalizeCollage() {
      if (!this.$refs.div || this.lightboxInitialized) return;

      console.log('🎯 Finalizing collage with items:', this.$options.propsData?.items);
      console.log('🎯 DOM elements before lightbox init:', Array.from(this.$refs.div.children).map(el => ({
        element: el,
        href: el.href,
        dataType: el.dataset.type,
        dataGallery: el.dataset.gallery,
        className: el.className
      })));

      this.createCollage();
      this.initializeLightbox();
      this.lightboxInitialized = true;
    },

    /* ---------- GLightbox ---------- */
    initializeLightbox() {
        // Добавляем принудительную проверку data-type атрибутов перед инициализацией
        const elements = Array.from(this.$refs.div.children);
        console.log('🔧 Pre-lightbox DOM check:', elements.map(el => ({
          href: el.href,
          dataType: el.getAttribute('data-type'),
          hasVideo: el.querySelector('video') !== null,
          tagName: el.children[0]?.tagName
        })));

        const myGallery = GLightbox({
          selector: `.glightbox-${this.$options.propsData.tuid}`,
        videosWidth: '90vw',
        videosHeight: '80vh',
        loop: true,
        autoplayVideos: false,
        touchNavigation: true,
        keyboardNavigation: true,
        closeOnOutsideClick: true,
        moreText: 'See more',
        moreLength: 60,
        cssEfects: { fade: { in: 'fadeIn', out: 'fadeOut' } },
      });

      // Отладка: логируем все события GLightbox
      myGallery.on('open', (data) => {
        console.log('🔥 GLightbox opened:', data);
      });

      myGallery.on('slide_before_load', (data) => {
        console.log('🎬 slide_before_load triggered:', {
          slideConfig: data.slideConfig,
          slideIndex: data.slideIndex,
          type: data.slideConfig?.type,
          href: data.slideConfig?.href
        });

        if (data.slideConfig?.type === 'video' && !data.slideNode.dataset.videoInjected) {
          console.log('🎥 Processing video slide');
          const originalVideoUrl = data.slideConfig.href;
          
          // Помечаем что видео начинает обрабатываться
          data.slideNode.dataset.processingVideo = 'true';
          data.slideNode.dataset.originalVideoUrl = originalVideoUrl;
          data.slideNode.dataset.originalType = 'video';
          
          // Заменяем на inline контент
          data.slideConfig.type = 'inline';
          data.slideConfig.content = '<div class="custom-video-placeholder">Loading video...</div>';
          
          console.log('🔄 Video config updated, scheduling custom video injection');
          
          // Используем более надежный способ ожидания
          this.$nextTick(() => {
            setTimeout(() => {
              console.log('⏰ Attempting to replace with custom video');
              this.replaceWithCustomVideo(data, originalVideoUrl);
            }, 50);
          });
        } else if (data.slideConfig?.type === 'video') {
          console.log('🔄 Video slide already processing/processed, skipping');
        }
      });

      // Fallback обработчик только для экстренных случаев
      myGallery.on('open', (data) => {
        console.log('🚪 Gallery opened');
        
        // Проверяем только если есть неработающие видео элементы через короткое время
        setTimeout(() => {
          const brokenVideos = document.querySelectorAll('.gslide video[src]:not([controls])');
          if (brokenVideos.length > 0) {
            console.log('🔧 Found broken video elements, applying fallback fix');
            brokenVideos.forEach(video => {
              video.controls = true;
              video.muted = true;
              video.playsInline = true;
              video.style.cssText = `
                max-width: 90vw; max-height: 80vh;
                width: auto; height: auto; object-fit: contain;`;
            });
          }
        }, 300);
      });

      myGallery.on('slide_after_load', (data) => {
        console.log('✅ slide_after_load:', {
          slideIndex: data.slideIndex,
          slideNode: data.slideNode,
          type: data.slideConfig?.type
        });
      });

      myGallery.on('slide_changed', (data) => {
        console.log('🔄 slide_changed:', data.slideIndex);
      });

      if (this.befLoad) {
        myGallery.on('slide_before_load', this.$options.propsData.befLoad);
      }
    },

    /* ---------- custom video injection ---------- */
    replaceWithCustomVideo(data, videoUrl) {
      const { slideNode } = data;
      
      console.log('🎥 replaceWithCustomVideo called:', {
        slideNode,
        videoUrl,
        slideNodeHTML: slideNode.innerHTML
      });
      
      // Добавляем несколько попыток поиска контейнера
      const findMediaContainer = (attempt = 1) => {
        console.log(`🔍 Attempt ${attempt} to find media container`);
        
        let mediaContainer = slideNode.querySelector('.ginlined-content') || 
                            slideNode.querySelector('.gslide-media') ||
                            slideNode.querySelector('.custom-video-placeholder')?.parentElement;
        
        console.log('📦 Found containers:', {
          ginlined: !!slideNode.querySelector('.ginlined-content'),
          gslideMedia: !!slideNode.querySelector('.gslide-media'),
          placeholder: !!slideNode.querySelector('.custom-video-placeholder')
        });
        
        if (!mediaContainer) {
          console.log('🏗️ Creating new media container structure');
          
          let innerContent = slideNode.querySelector('.gslide-inner-content');
          if (!innerContent) {
            innerContent = document.createElement('div');
            innerContent.className = 'gslide-inner-content';
            slideNode.appendChild(innerContent);
          }
          
          const gContainer = document.createElement('div');
          gContainer.className = 'ginner-container';
          
          mediaContainer = document.createElement('div');
          mediaContainer.className = 'gslide-media';
          
          gContainer.appendChild(mediaContainer);
          innerContent.appendChild(gContainer);
        }
        
        console.log('✅ Media container ready:', mediaContainer);
        return mediaContainer;
      };
      
      const injectVideo = () => {
        try {
          const mediaContainer = findMediaContainer();
          
          console.log('🧹 Clearing media container');
          mediaContainer.innerHTML = '';
          
                  const wrapper = document.createElement('div');
        wrapper.style.cssText = `
          width: 100%; height: 100%;
          display: flex !important; align-items: center; justify-content: center;
          background: #000; position: relative; z-index: 9999;`;
        
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.autoplay = false;
        video.style.cssText = `
          max-width: 90vw !important; max-height: 80vh !important;
          width: auto !important; height: auto !important; 
          object-fit: contain !important; display: block !important;
          background: #000; z-index: 10000; position: relative;`;
          
          // Добавляем обработчики событий для отладки
          video.addEventListener('loadstart', () => console.log('📹 Video loadstart'));
          video.addEventListener('loadedmetadata', () => console.log('📹 Video loadedmetadata'));
          video.addEventListener('canplay', () => console.log('📹 Video canplay'));
          video.addEventListener('error', (e) => console.error('❌ Video error:', e));
          
          wrapper.appendChild(video);
          mediaContainer.appendChild(wrapper);
          
          // Убираем классы загрузки
          slideNode.classList.add('loaded');
          slideNode.classList.remove('loading');
          
          slideNode.querySelectorAll('.gloader').forEach(loader => {
            loader.style.display = 'none';
          });
          
          slideNode.querySelectorAll('.gslide-description').forEach(desc => {
            desc.remove();
          });
          
          // Принудительно показываем элементы
          slideNode.style.cssText += 'display: block !important; visibility: visible !important; opacity: 1 !important;';
          mediaContainer.style.cssText += 'display: block !important; visibility: visible !important; opacity: 1 !important;';
          wrapper.style.cssText += 'display: flex !important; visibility: visible !important; opacity: 1 !important;';
          
          // Убираем все лоадеры и плейсхолдеры принудительно
          slideNode.querySelectorAll('.gloader, .gslide-description, .custom-video-placeholder').forEach(el => {
            el.style.display = 'none';
            el.remove();
          });
          
          console.log('🎬 Video injection complete, loading video');
          video.load();
          
          // Дополнительная проверка через короткое время
          setTimeout(() => {
            if (video.style.display === 'none' || wrapper.style.display === 'none') {
              console.log('⚠️ Video element hidden, forcing visibility');
              video.style.cssText += 'display: block !important;';
              wrapper.style.cssText += 'display: flex !important;';
            }
            console.log('📊 Final video element state:', {
              videoDisplay: video.style.display,
              wrapperDisplay: wrapper.style.display,
              containerDisplay: mediaContainer.style.display,
              slideDisplay: slideNode.style.display
            });
          }, 100);
          
        } catch (error) {
          console.error('❌ Error in video injection:', error);
        }
      };
      
      // Делаем одну попытку инъекции, но проверяем готовность контейнера
      const attemptInjection = (attempt = 1, maxAttempts = 3) => {
        if (attempt > maxAttempts) {
          console.error('❌ Failed to inject video after', maxAttempts, 'attempts');
          return;
        }
        
        const container = slideNode.querySelector('.gslide-media');
        if (container && !slideNode.dataset.videoInjected) {
          console.log(`✅ Container ready on attempt ${attempt}, injecting video`);
          slideNode.dataset.videoInjected = 'true';
          injectVideo();
        } else if (!slideNode.dataset.videoInjected) {
          console.log(`⏳ Attempt ${attempt}: container not ready, retrying in ${50 * attempt}ms`);
          setTimeout(() => attemptInjection(attempt + 1, maxAttempts), 50 * attempt);
        }
      };
      
      attemptInjection();
    },

    /* ---------- collage calculation (unchanged) ---------- */
    createCollage() {
      if (!this.$refs.div) return;
      
      const settings = {
        albumWidth: 0,
        allowPartialLastRow: false,
        direction: 'vertical',
        display: 'inline-block',
        effect: 'default',
        fadeSpeed: 2000,
        padding: 0,
        targetHeight: 200,
      };
      
      const resizeRow = (obj, row, settings) => {
        const extras = settings.padding * (obj.length - 1) + obj.length * obj[0][3];
        const available = settings.albumWidth - extras;
        const ratio = available / (row - extras);
        let track = extras;

        obj.forEach((o, i) => {
          let w = Math.floor(o[1] * ratio);
          let h = Math.floor(o[2] * ratio);
          const last = i === obj.length - 1;

          track += w;
          if (last && track < settings.albumWidth) w += settings.albumWidth - track;

          w--;
          Object.assign(o[0].style, {
            width: w + 'px',
            height: h + 'px',
            marginBottom: settings.padding + 'px',
            marginRight: last ? 0 : settings.padding + 'px',
            display: settings.display,
            verticalAlign: 'bottom',
            overflow: 'hidden',
          });
        });
      };

      let row = 0,
        elements = [],
        rowNum = 1;

      settings.padding = this.$options.propsData.padding || 0;
      settings.albumWidth = this.$refs.div.clientWidth;

      [...this.$refs.div.children].forEach((gl, idx) => {
        const el = gl.children[0];

        // reset inline styles
        ['width', 'height', 'marginBottom', 'marginRight', 'display', 'verticalAlign', 'overflow'].forEach(
          (p) => (el.style[p] = '')
        );

        let w, h;
        if (el.tagName === 'VIDEO') {
          w = el.videoWidth || 300;
          h = el.videoHeight || 169;
        } else {
          w = el.naturalWidth || 300;
          h = el.naturalHeight || 200;
        }

        const bw = 0,
          bh = 0;
        const nw = Math.ceil((w / h) * settings.targetHeight);
        const nh = Math.ceil(settings.targetHeight);

        elements.push([el, nw, nh, bw, bh]);
        row += nw + bw + settings.padding;

        if (row > settings.albumWidth && elements.length) {
          resizeRow(elements, row - settings.padding, settings, rowNum++);
          row = 0;
          elements = [];
        }
        if (idx === this.$refs.div.children.length - 1 && elements.length) {
          resizeRow(elements, row, settings, rowNum++);
        }
      });
    },

    /* ---------- resize debounce ---------- */
    resizes() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.createCollage(), 300);
    },
  },
};
</script>
